import { Injectable } from '@angular/core';
import {BehaviorSubject, Subject} from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class DraggableService {

  private _draggableElement$ = new BehaviorSubject(null);
  private _onDrop$ = new Subject();

  get draggableElement$(){
    return this._draggableElement$.asObservable();
  }

  set draggableElement$(val:any){
    this._draggableElement$.next(val);
  }

  get draggableElementVal(){
    return this._draggableElement$.getValue();
  }

  get onDrop$(){
    return this._onDrop$.asObservable();
  }

  set onDrop$(val:any){
    this._onDrop$.next(val);
  }

  constructor() {}

}
